import { useState, useEffect } from 'react';
import { X, ImageIcon, Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GalleryPicker = ({ token, open, onClose, onSelect }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!open) return;
    const authToken = token || localStorage.getItem('token');
    setLoading(true);
    axios
      .get(`${BACKEND_URL}/api/imgtool/my-images`, { headers: { Authorization: `Bearer ${authToken}` } })
      .then((res) => setImages(res.data.images || []))
      .catch(() => setImages([]))
      .finally(() => setLoading(false));
  }, [open, token]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="gallery-picker">
      <div className="bg-[#141021] border border-violet-500/30 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <div className="flex items-center gap-2">
            <ImageIcon className="w-5 h-5 text-violet-300" />
            <h3 className="gotham-bold text-white">Elegir de mi galería</h3>
          </div>
          <button onClick={onClose} className="text-white/60 hover:text-white" data-testid="gallery-picker-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 overflow-y-auto">
          {loading ? (
            <div className="flex justify-center py-12">
              <Loader2 className="w-8 h-8 text-violet-400 animate-spin" />
            </div>
          ) : images.length === 0 ? (
            <div className="text-center py-12">
              <ImageIcon className="w-10 h-10 text-white/20 mx-auto mb-3" />
              <p className="text-white/50 text-sm">Aún no tienes imágenes en tu galería. Sube una primero.</p>
            </div>
          ) : (
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
              {images.map((img) => (
                <button
                  key={img.id}
                  onClick={() => { onSelect(img.url); onClose(); }}
                  className="group relative rounded-lg overflow-hidden border border-white/10 hover:border-violet-500 transition-colors aspect-square bg-black/30"
                  data-testid={`gallery-pick-${img.id}`}
                >
                  <img src={img.url} alt={img.filename || 'imagen'} className="w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GalleryPicker;
